export { SimpleEventRegistrantsPage } from './SimpleEventRegistrantsPage';
